const validateName = ({value, required, minLength}) => {

  if (required && value === '') {
    return 'Введите, пожалуйста, Ваше имя';
  }

  if (minLength && minLength > value.length) {
    return `Минимальное количество символов ${minLength}`;
  }

  return '';
}

// https://regex101.com/r/pMUvPe/4
const EMAIL_REGEX = /^([\w!#$%&'*+./=?^`{|}~-]+)?[\w!#$%&'*+/=?^`{|}~-]@[\dA-Za-z-]+()(\.[\dA-Za-z-]+)*(\.[A-Za-z]+)$/;

const validateEmail = ({value, required, pattern = EMAIL_REGEX}) => {
  const errorMessage = 'Пожалуйста, введите корректный email';
  if (required && value === '') {
    return errorMessage;
  }

  if (value && !pattern.test(value)) {
    return errorMessage;
  }

  return '';
};

const renderError = (inputElement, errorElement, errorMessage) => {
  if (errorMessage) {
    inputElement.focus();
  }

  if (errorElement.classList.contains('error')) {
    errorElement.innerHTML = errorMessage;
  }
}

const checkValidationForm = (formSelector) => {
  const inputName = document.querySelector(`${formSelector} .form__input--user input`);
  const inputEmail = document.querySelector(`${formSelector} .form__input--email input`);
  const form = document.querySelector(formSelector);

  form.addEventListener('submit', (e) => {
    const nextNameSibling = inputName.nextElementSibling;
    const nextEmailSibling = inputEmail.nextElementSibling;

    const errorNameMessage = validateName({value: inputName.value, required: true, minLength: 2});
    const errorEmailMessage = validateEmail({value: inputEmail.value, required: true});


    if (errorNameMessage || errorEmailMessage) {
      e.preventDefault();

      renderError(inputName, nextNameSibling, errorNameMessage);
      renderError(inputEmail, nextEmailSibling, errorEmailMessage);

      form.querySelector('input[name=name]').addEventListener('input', (e) => {
        const errorMessage = validateName({value: e.target.value, required: true, minLength: 2});

        renderError(inputName, nextNameSibling, errorMessage);
      });
      form.querySelector('input[name=email]').addEventListener('input', (e) => {
        const errorMessage = validateEmail({value: e.target.value, required: true});

        renderError(inputEmail, nextEmailSibling, errorMessage);
      })
    }

  });

}

checkValidationForm('.validate-one');
checkValidationForm('.validate-two');

const handleFocusByClick = () => {

}

document.querySelector('#start').addEventListener('click', (e) => {
  e.preventDefault();
  document.querySelector('#order').scrollIntoView({ behaviour: 'smooth' });
  document.querySelector('#first-name-focus').focus();
});
